module.exports = __webpack_public_path__ + "img/bp-logo.006a71e2.svg";